'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _result = require('folktale/result');

var _result2 = _interopRequireDefault(_result);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get .pagesPaths from pluginOptions
 * @sig Options -> Result String[]
 * @param {{pagesPaths: String[]}} options plugin options
 * @return {Result<String[]>} pagesPaths Result
 */
var getPagesPaths = function getPagesPaths(options) {
  if ((0, _ramda.isNil)(options)) {
    return _result2.default.Error('Null plugin options');
  }

  var pagesPaths = options.pagesPaths;


  if ((0, _ramda.isNil)(pagesPaths)) {
    return _result2.default.Error('Null pluginOptions.pagesPaths');
  }

  // Should test if pagesPaths is an Array?
  // Should test if pagesPaths is empty?

  return _result2.default.Ok(pagesPaths);
};

exports.default = getPagesPaths;


//////////////////
// WEBPACK FOOTER
// ./~/ptz-i18n/dist/getPagesPaths.js
// module id = 182
// module chunks = 34471704633725 35783957827783 216468464745311